import React from 'react';

function GeneralT() {
  return <div></div>;
}

export default GeneralT;
